var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgLinkdin = props => /*#__PURE__*/React.createElement("svg", _extends({
  fill: "transparent",
  height: 24,
  viewBox: "0 0 24 24",
  width: 24,
  xmlns: "http://www.w3.org/2000/svg"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "m16 8c1.5913 0 3.1174.63214 4.2426 1.75736 1.1253 1.12524 1.7574 2.65134 1.7574 4.24264v7h-4v-7c0-.5304-.2107-1.0391-.5858-1.4142s-.8838-.5858-1.4142-.5858-1.0391.2107-1.4142.5858-.5858.8838-.5858 1.4142v7h-4v-7c0-1.5913.6321-3.1174 1.7574-4.24264 1.1252-1.12522 2.6513-1.75736 4.2426-1.75736z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m6 9h-4v12h4z"
}), /*#__PURE__*/React.createElement("path", {
  d: "m4 6c1.10457 0 2-.89543 2-2s-.89543-2-2-2-2 .89543-2 2 .89543 2 2 2z"
}))));
export default SvgLinkdin;